"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaDirective = void 0;
exports.schemaDirective = {
    created( /*el, binding, vnode, prevNode*/) { },
    beforeMount(el, binding /*, vnode: any*/) {
        // console.log('beforeMount');
        const model = binding.value;
        if (model && model.$bind) {
            model.$bind(el, binding.modifiers);
        }
    },
    mounted( /*el, binding, node*/) { },
    beforeUpdate(el, binding) {
        // console.log('beforeUpdate', binding);
        if (binding.oldValue !== binding.value) {
            if (binding.oldValue && binding.oldValue.$unbind) {
                binding.oldValue.$unbind(el);
            }
            if (binding.value && binding.value.$bind) {
                binding.value.$bind(el, binding.modifiers);
            }
        }
    },
    updated() { },
    beforeUnmount(el, binding /*, vnode: any*/) {
        // console.log('beforeUnmount');
        const model = binding.value;
        if (model && model.$unbind) {
            model.$unbind(el);
        }
    },
    unmounted() { }
};
exports.default = exports.schemaDirective;
//# sourceMappingURL=schemaDirective.js.map